import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { Modal, Table } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import ReactToPrint from 'react-to-print';
import { DataContext } from '../../../init/getData';
import { FcPortraitMode, FcAbout, FcInTransit, FcHome } from "react-icons/fc";
import Loader from '../../../components/loader/loader';
import { datePrintFormatter } from '../../../dynamic/dateFormatter';
import { print } from "../../../dynamic/print";

import { Button, Card } from 'antd';




const AccountStatementReport = (props) => {

  const { api, userData, settingData, serverApi, localApi, devData, selectedCompany } = useContext(DataContext);


  const { showModal, toggleModal, idRow, report, reportRef, filter, selectedAccount,
    selectedCurrency, mainCurrency, secondaryCurrency, currency } = props;

  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;
  const statementReportRef = useRef(null);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (showModal) {
      fetchData();
    }
    console.log("acc", selectedAccount);
  }, [showModal]);


  const fetchData = async () => {
    try {
      setIsLoading(true);

      const data = {
        filter,
      }
      const response = await api.get(`/accountStatement/getAll`, { params: data });
      if (response) {
        const data = response?.data?.data;
        setData(data);
      }

      setIsLoading(false);
    } catch (error) {
      console.error('Error refreshing data Contact Support');
    }
  };

  // --- MODIFIED: Always calculate totals for BOTH currencies & fixed balance calc ---
  const totals = useMemo(() => {
    // Main Currency Totals
    const mainTotalDebit = data.reduce((sum, item) => sum + (parseFloat(item.totalDebit) || 0), 0);
    const mainTotalCredit = data.reduce((sum, item) => sum + (parseFloat(item.totalCredit) || 0), 0);
    // --- BALANCE CALCULATION AS REQUESTED: Credit - Debit ---
    const mainTotalBalance = mainTotalCredit - mainTotalDebit;

    // Secondary Currency Totals
    const secondaryTotalDebit = data.reduce((sum, item) => sum + (parseFloat(item.secondaryTotalDebit) || 0), 0);
    const secondaryTotalCredit = data.reduce((sum, item) => sum + (parseFloat(item.secondaryTotalCredit) || 0), 0);
    // --- BALANCE CALCULATION AS REQUESTED: Credit - Debit ---
    const secondaryTotalBalance = secondaryTotalCredit - secondaryTotalDebit;
    
    return { 
      mainTotalDebit, 
      mainTotalCredit, 
      mainTotalBalance,
      secondaryTotalDebit,
      secondaryTotalCredit,
      secondaryTotalBalance
    };
  }, [data]); // No longer depends on 'currency'
  // --- END MODIFICATION ---


  return (
    <Modal show={showModal} backdrop="static" size='xl' onHide={toggleModal}>
      <Modal.Header style={{ background: "#39aaa5", display: "flex", justifyContent: "center" }}>
        <div>
          <Modal.Title style={{ color: "white" }}> Report </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>

        {isLoading &&
          <Loader />
        }


        {!isLoading &&
          <Card ref={statementReportRef}>
            {/* Title */}
            <div style={{ textAlign: 'center', color: '#000', marginBottom: 24 }}>
              {/* Main Title (Larger) */}
              <div style={{ fontSize: 30, fontWeight: 'bold' }}>STATEMENT OF ACCOUNT</div>
              {/* Company Name (Smaller) */}
              <div style={{ fontSize: 14, marginTop: '8px' }}>{selectedCompany?.name}</div>
            </div>

            {/* Header Information */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24, fontSize: 14 }}>
              <div><strong>Period:</strong> {filter.fromDate} to {filter.toDate}</div>
              <div><strong>Account:</strong> {selectedAccount?.label || 'All Accounts'}</div>
              <div>
                <strong>Currency:</strong>{' '}
                {/* This currency in the header now only reflects the *table body* display */}
                {currency === 'main' && mainCurrency?.code}
                {currency === 'secondary' && secondaryCurrency?.code}
              </div>
            </div>

            {/* Table */}
            <Table style={{ width: '100%' }} bordered hover>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Details</th>
                  <th>Payment</th>
                  <th style={{ textAlign: 'right' }}>Debit</th>
                  <th style={{ textAlign: 'right' }}>Credit</th>
                  <th style={{ textAlign: 'right' }}>Balance</th>
                </tr>
              </thead>

              <tbody>
                {data?.map(item => (
                  <tr key={item.id}>
                    <td>{item?.journalVoucherId}</td>
                    <td>{item?.journalVoucher?.date}</td>
                    <td>{item?.journalVoucher?.type}</td>
                    <td>{item?.journalVoucher?.details}</td>
                    <td>{item?.journalVoucher?.paymentType}</td>
                    {currency == 'main' &&
                      <>
                        <td style={{ textAlign: 'right' }}>{numberFormatter(item?.totalDebit)}</td>
                        <td style={{ textAlign: 'right' }}>{numberFormatter(item?.totalCredit)}</td>
                        <td style={{ textAlign: 'right' }}>{numberFormatter(item?.cumulativeBalance)}</td>
                      </>
                    }
                    {currency == 'secondary' &&
                      <>
                        <td style={{ textAlign: 'right' }}>{numberFormatter(item?.secondaryTotalDebit)}</td>
                        <td style={{ textAlign: 'right' }}>{numberFormatter(item?.secondaryTotalCredit)}</td>
                        <td style={{ textAlign: 'right' }}>{numberFormatter(item?.secondaryCumulativeBalance)}</td>
                      </>
                    }
                  </tr>
                ))}
              </tbody>

              {/* --- MODIFIED: Totals Footer --- */}
              <tfoot style={{ borderTop: '1px solid #000' }}>
              <tr>
                <td colSpan="5" style={{ padding: '8px' }}>
                  <strong>Totals</strong>
                </td>

                {/* MODIFIED: Total Debit based on selected currency */}
                <td style={{ textAlign: 'right', padding: '8px' }}>
                  {currency === 'main' && numberFormatter(totals.mainTotalDebit)}
                  {currency === 'secondary' && numberFormatter(totals.secondaryTotalDebit)}
                </td>

                {/* MODIFIED: Total Credit based on selected currency */}
                <td style={{ textAlign: 'right', padding: '8px' }}>
                  {currency === 'main' && numberFormatter(totals.mainTotalCredit)}
                  {currency === 'secondary' && numberFormatter(totals.secondaryTotalCredit)}
                </td>

                {/* UNCHANGED: Balance column shows both currencies */}
                 <td style={{ textAlign: 'right', padding: '8px', fontWeight: 'bold' }}>
                  {numberFormatter(totals.mainTotalBalance < 0 ? totals.mainTotalBalance * -1 : totals.mainTotalBalance)} {mainCurrency?.code}
                  {secondaryCurrency?.code && (
                    <>
                      <br />
                      {numberFormatter(totals.secondaryTotalBalance < 0 ? totals.secondaryTotalBalance * -1 : totals.secondaryTotalBalance)} {secondaryCurrency?.code}
                    </>
                  )}
                </td>
              </tr>
            </tfoot>
            {/* --- END MODIFICATION --- */}
              
            </Table>

            {/* Footer */}
            <div style={{ marginTop: 24, textAlign: 'right', fontSize: 12, color: '#000', padding: '10px 0' }}>
              Generated on: {new Date().toLocaleDateString()} by {userData.name}
            </div>
          </Card>
        }
      </Modal.Body>

      <div className="modal-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button type="button" className="btn btn-secondary" style={{ backgroundColor: '#1f2937' }} onClick={toggleModal}>Close</button>

          <ReactToPrint
            trigger={() => <button type="button" style={{ backgroundColor: '#1d7790' }} className="btn btn-primary">Print</button>}
            content={() => statementReportRef.current}
          />
        </div>
      </div>

    </Modal>
  );
};

export default AccountStatementReport;